import { Link } from "react-router-dom";
import type { Title } from "@/mocks/titles";

interface Props {
  item: Title;
  rank?: number;
  compact?: boolean;
}

export default function PosterCard({ item, rank, compact = false }: Props) {
  return (
    <Link to={`/detail/${item.id}`} className="group block cursor-pointer">
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-secondary-900">
        <img
          src={item.poster}
          alt={`${item.title}中文字幕在线观看海报`}
          title={`${item.title} - 中文字幕在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/15 to-transparent"></div>

        <span className="absolute left-2 top-2 rounded bg-primary-950/75 px-1.5 py-0.5 text-[11px] text-background-100">
          {item.type === "movie" ? "电影" : "剧集"}
        </span>
        <span className="absolute right-2 top-2 rounded bg-accent-500 px-1.5 py-0.5 text-[11px] font-bold text-primary-950">
          {item.rating.toFixed(1)}
        </span>

        {typeof rank === "number" ? (
          <span className="absolute bottom-2 right-2 flex h-7 w-7 items-center justify-center rounded bg-primary-950/70 text-xs font-bold text-accent-400">
            {rank}
          </span>
        ) : null}

        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <p className={`truncate font-medium text-background-50 ${compact ? "text-[13px]" : "text-sm"}`}>
            {item.title}
          </p>
          <p className="mt-1 truncate text-[11px] text-background-300">
            {item.year} · {item.genres.slice(0, 2).join(" / ")}
          </p>
        </div>

        <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500/95">
            <i className="ri-play-fill text-xl text-primary-950" aria-hidden="true"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}